import readFile from 'utils/dom/input/readFile.util';

const fromFileToPromiseString = (file) => readFile({ file });

export default fromFileToPromiseString;
